import React, {useRef, useState, useEffect} from 'react';
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/hotel/placeActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import * as Yup from "yup";
import {  LB_FLOORS, LB_TOTAL_SUITS, REQUIRED } from "../../../components/i18n/i18n";
import {ErrorMessage, useForm} from "react-hook-form";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup, InputGroupAddon,
    Label,
    Row
} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {placeService} from "../../../jwt/_services/hotel/placeService";
import {
    FL_CATEGORY,
    FL_CODE, FL_RESERVATION_NEEDED,
    FL_STATUS,
} from "../../../components/i18n/formLabels";
import {PH_CODE} from "../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import SelectGeneric from "../../../components/select/selectGeneric";
import {placeProvider} from "../../../providers/placeProvider";
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import MenuSection from "./menuSection/MenuSection";
import {typePlaceProvider} from "../../../providers/typePlaceProvider";
import {MapPickerModal} from "../../../components/map/MapPickerModal";
import {placeMediaService} from "../../../jwt/_services/core/placeMediaService";
import PlaceLangs from "../../core/place/_langs";
import PlaceRestaurantLangs from "../../core/place/_langsRestaurant";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

const RestaurantControllerForm = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { udn, app, category : categoryCode, editMode, disableInputs, domainObject, mapConfig, userIsAdmin } = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [hasMenu, setHasMenu] = useState( domainObject?.hasMenus !== undefined ? domainObject?.hasMenus : null );
    const [needReservation, setNeedReservation] = useState(domainObject?.needReservation !== undefined ? domainObject?.needReservation : true );
    const [category, setCategory] = useState(domainObject?.category || null);
    const [parentPlace, seParentPlace] = useState(domainObject?.parentPlace || null);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [langsRestaurant, setLangsRestaurant] = useState(domainObject?.langsRestaurant || []);

    const [weather, setWeather] = useState( domainObject?.weather || false);
    const [contactCategory, setContactCategory] = useState( domainObject?.contactCategory || null);
    const [typePlace, setTypePlace] = useState( domainObject?.typePlace || null);
    const [position, setPosition] = useState(editMode ? {
        lat: parseFloat(domainObject?.latitude),
        lng: parseFloat(domainObject?.longitude)
    } : mapConfig?.mapOptions?.center );


    const [showMapModal, setShowMapModal] = useState(true);
    const modalMapRef = useRef(null);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);


    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: (domainObject?.code || (udn?.code || 'place') + '_' + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
                status: domainObject?.status,
                needReservation: domainObject?.needReservation,
                colorMarkerMap: domainObject?.colorMarkerMap,
                iconMap: domainObject?.iconMap,
                latitude: domainObject?.latitude ?? 0.0,
                longitude: domainObject?.longitude ?? 0.0,
                level: domainObject?.level,
                showOrder: domainObject?.showOrder,
                houseId: domainObject?.houseId,
                floors: domainObject?.floors,
                totalSuits: domainObject?.totalSuits,
                menuFontColor: domainObject?.menuFontColor,
                menuBackgroundColor: domainObject?.menuBackgroundColor,
                menuBackground: domainObject?.menuBackground,
                menuLogo: domainObject?.menuLogo,
                menuSignature: domainObject?.menuSignature,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const showMap = () => {
        setShowMapModal(true);
        modalMapRef.current.showModal(mapConfig);
    }


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: (domainObject?.code || (udn?.code || 'place') + '_' + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            status: domainObject?.status,
            needReservation: domainObject?.needReservation,
            colorMarkerMap: domainObject?.colorMarkerMap,
            iconMap: domainObject?.iconMap,
            latitude: domainObject?.latitude ?? 0.0,
            longitude: domainObject?.longitude ?? 0.0,
            level: domainObject?.level,
            showOrder: domainObject?.showOrder,
            houseId: domainObject?.houseId,
            floors: domainObject?.floors,
            totalSuits: domainObject?.totalSuits,
            menuFontColor: domainObject?.menuFontColor,
            menuBackgroundColor: domainObject?.menuBackgroundColor,
            menuBackground: domainObject?.menuBackground,
            menuLogo: domainObject?.menuLogo,
            menuSignature: domainObject?.menuSignature,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                ...data,
                status : status,
                needReservation : needReservation,
                hasMenus : hasMenu,

                udn : { id: udn?.id },
                category : { id: category },

                langs: langs,
                langsRestaurant : langsRestaurant,
            }
        }
        
        if (position) {
            dataRequest.item.latitude = parseFloat(position.lat);
            dataRequest.item.longitude = parseFloat(position.lng);
        }

        if (parentPlace)
            dataRequest.item.parentPlace = { id : parentPlace }
        else
            dataRequest.item.parentPlace = null;

        // console.log(dataRequest);
        // return;

        setLoading(path,true);

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, placeService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, placeService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    const notImplementedAction = () => {
        console.log('sin implementar');
    }

    const onLatChange = (value ) => {
        setPosition({
            ...position,
            lat : value
        })
    }

    const onLngChange = ( value ) => {
        setPosition({
            ...position,
            lng : value
        })
    }

    const refreshObject = () => genericIndexedActions.get(path, placeService, domainObject?.id, app?.fbDataBase?.id);


    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={editMode ? 'card-modal-big' : 'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + '  /  ' + (domainObject?.title || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { 'uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={placeService} askForConfirmation={false} />
                                {/*<GenericButton*/}
                                {/*    style={'danger-secondary'}*/}
                                {/*    toolTip={TT_DELETE}*/}
                                {/*    icon={'fa-trash'}*/}
                                {/*    permission={'delete'}*/}
                                {/*    onClick={notImplementedAction}*/}
                                {/*/>*/}
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        {/* DATOS */}
                        <Col md={editMode ? "4" : "12"}>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>{ FL_CODE }</Label>
                                        <Input
                                            type="text"
                                            name="code"
                                            placeholder={ PH_CODE }
                                            innerRef={register}
                                            disabled={disableInputs}
                                            className={(errors.code ? ' is-invalid' : '')}
                                        />
                                        { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md="1"></Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>{ FL_RESERVATION_NEEDED }</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={ needReservation }
                                            disabled={ disableInputs }
                                            onChange={ _ => setNeedReservation(!needReservation) }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>{ FL_STATUS }</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={ status }
                                            disabled={ disableInputs }
                                            onChange={ _ => setStatus(!status) }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>Orden</Label>
                                        <Input
                                            type="number"
                                            name="showOrder"
                                            min="1"
                                            placeholder="Orden"
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label>{ FL_CATEGORY }</Label>
                                        <br/>
                                        <SelectGeneric
                                            isDisabled={ disableInputs }
                                            initialValue={ category }
                                            setExternalValue={ setCategory }
                                            provider={hotelCategoryProvider}
                                            getAllCategories={true}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>

                        {/* IMAGE PICKER */}
                        <Col md={editMode ? "8" : "0"}>
                            { domainObject?.id &&
                                <ImagePicker
                                className={'place'}
                                title={'Restaurante Media'}
                                app={app}
                                service={placeService}
                                baseMediaService={placeMediaService}
                                objectMedia={domainObject}
                                afterUpload={refreshObject}
                            /> }

                        </Col>
                    </Row>
                    <Row>
                        <Col md={editMode ? "6" : "12"}>
                            {
                                userIsAdmin ? <>
                                    <div className={'form-container'}>
                                        <div className={''}>
                                            <h2>{'Configuración de mapa'}</h2>
                                        </div>
                                        <div className={''}>
                                            <Row>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label>{'Ubicado en (Casa o Edificio)'}</Label>
                                                        <br/>
                                                        <SelectGeneric
                                                            isDisabled={disableInputs}
                                                            initialValue={parentPlace}
                                                            setExternalValue={seParentPlace}
                                                            provider={placeProvider}
                                                            customFilter={{
                                                                item: {
                                                                    udn: {id: udn.id},
                                                                    categoryCodes: category
                                                                }
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label>Latitud y longitud</Label>
                                                        <InputGroup>
                                                            <Button color=" background-color-primary" onClick={showMap}>
                                                                <i className="fas fa-map-marker-alt text-white"/>
                                                            </Button>
                                                            <InputGroupAddon addonType="append">
                                                                <Input type="number"
                                                                       name="lat"
                                                                       value={position?.lat}
                                                                       className={'lat-lng-input'}
                                                                       step={'0.0000001'}
                                                                       onChange={e => onLatChange(e.target.value)}
                                                                />
                                                            </InputGroupAddon>
                                                            <InputGroupAddon addonType="append">
                                                                <Input type="number"
                                                                       name="lng"
                                                                       className={'lat-lng-input'}
                                                                       value={position?.lng}
                                                                       step={'0.0000001'}
                                                                       onChange={e => onLngChange(e.target.value)}
                                                                />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                        <ErrorMessage errors={errors} name="latitude" component="div"
                                                                      className="invalid-feedback"/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label>{'Color de pin'}</Label>
                                                        <Input
                                                            type="color"
                                                            name="colorMarkerMap"
                                                            innerRef={register}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label>{'Icono'}</Label>
                                                        <Input
                                                            type="text"
                                                            name="iconMap"
                                                            placeholder="Icono"
                                                            innerRef={register}
                                                        />
                                                    </FormGroup>
                                                </Col>

                                            </Row>
                                        </div>
                                    </div>
                                </> : null
                            }
                            {
                                userIsAdmin ? <>
                                    <div className={'form-container'}>
                                        <div className={''}>
                                            <h2>{'Configuración adicional'}</h2>
                                        </div>
                                        <div className={''}>
                                            <Row>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label>Nivel</Label>
                                                        <Input
                                                            type="number"
                                                            name="level"
                                                            step={1}
                                                            innerRef={register}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label>{LB_FLOORS}</Label>
                                                        <Input
                                                            type="number"
                                                            name="floors"
                                                            step={1}
                                                            innerRef={register}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label>{LB_TOTAL_SUITS}</Label>
                                                        <Input
                                                            type="number"
                                                            name="totalSuits"
                                                            step={1}
                                                            innerRef={register}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label>Clima</Label>
                                                        <br/>
                                                        <Switch
                                                            animate={true}
                                                            offText={"No"}
                                                            onText={"Si"}
                                                            value={weather}
                                                            onChange={_ => setWeather(!weather)}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <Label>Tipo de lugar</Label>
                                                        <br/>
                                                        <SelectGeneric
                                                            initialValue={typePlace}
                                                            setExternalValue={setTypePlace}
                                                            provider={typePlaceProvider}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <Label>Categoría de contacto</Label>
                                                        <br/>
                                                        <SelectGeneric
                                                            initialValue={contactCategory}
                                                            setExternalValue={setContactCategory}
                                                            provider={hotelCategoryProvider}
                                                            getAllCategories={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </> : null
                            }
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Información internacional'}</h2>
                                </div>
                                <div className={''}>
                                    <PlaceLangs
                                        appCode={app?.code}
                                        langs={langs}
                                        setLangs={setLangs}
                                        translatableLangs={domainObject?.translatedLangs || []}/>
                                </div>
                            </div>

                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Información internacional restaurante/spa '}</h2>
                                </div>
                                <div className={''}>
                                    <PlaceRestaurantLangs
                                        langs={langsRestaurant}
                                        setLangs={setLangsRestaurant}
                                        translatableLangs={domainObject?.translatedLangRest || []}/>
                                </div>
                            </div>
                        </Col>
                        <Col md={editMode ? "6" : "12"}>
                            <Row>
                                {
                                    userIsAdmin ? <>
                                        <div className={'form-container'}>
                                            <div className={''}>
                                                <h2>{'Configuración de Menus'}</h2>
                                            </div>
                                            <div className={''}>
                                                <Row>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>Tiene menus ?</Label>
                                                            <br/>
                                                            <Switch
                                                                animate={true}
                                                                offText={"No"}
                                                                onText={"Si"}
                                                                value={hasMenu}
                                                                onChange={_ => setHasMenu(!hasMenu)}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>Color de fuente del menu</Label>
                                                            <Input
                                                                type="color"
                                                                name="menuFontColor"
                                                                innerRef={register}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>Color de fondo del menu</Label>
                                                            <Input
                                                                type="color"
                                                                name="menuBackgroundColor"
                                                                innerRef={register}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>{'Imagen de fondo de Menus'}</Label>
                                                            <Input
                                                                type="text"
                                                                name="menuBackground"
                                                                placeholder={''}
                                                                innerRef={register}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>{'Logo'}</Label>
                                                            <Input
                                                                type="text"
                                                                name="menuLogo"
                                                                placeholder={''}
                                                                innerRef={register}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label>{'Firma del Chef'}</Label>
                                                            <Input
                                                                type="text"
                                                                name="menuSignature"
                                                                placeholder={''}
                                                                innerRef={register}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </> : null
                                }

                            </Row>
                            <Row>
                                <Col md="12" className={'remove-padding'}>
                                    {
                                        domainObject?.id &&
                                        <MenuSection path={path}/>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Form>
        {
            showMapModal &&
            <MapPickerModal
                ref={modalMapRef}
                setPosition={setPosition}
                initialPosition={position}
                googleConfig={mapConfig}
                updateMarkerPosition={true}/>
        }
        {
            showModal &&
            <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(RestaurantControllerForm)